export default ['PROCESSED', 'RECEIVED', 'NOT RECEIVED', 'DELETED'];